import { get, post, put, del } from 'utils/methods';

export function getPackagesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}packages`, data, headers);
}

export function addNewPackageApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/package`, data, headers);
}

export function editPackageApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/package`, data, headers);
}

export function addConfigurationToPackageApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/package/configuration`, data, headers);
}

export function deleteConfigurationFromPackageApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/package/configuration`, data, headers);
}

export function togglePackageStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/package/status`, data, headers);
}
